const ActionType ={
    profileData:'PROFILE_DATA',
    sideBarMenuItems:"SIDE_BAR_MENU_ITEM",
    storeCmsBillerForm:"STORE_CMS_BILLLER_FORM",
    isToastOpen:"IS_TOAST_OPEN",
    accountBalance:'ACCOUNT_BALANCE',
    dynamicMenu:"DYNAMIC_MENUS",
    logout:"LOGOUT"
}

export default ActionType;